import { ArrowRight } from "lucide-react";
import React from "react";

const ResumeButton = () => {
  return (
    <button className="lg:mt-12 mt10 mb-44 min-h-screen">
        
      <a
        href="/Md%20Shakil%20Hossain%20-%20FullStack-Engineer_Resume.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="rounded bg-blue-500 hover:bg-blue-700 transition duration-200 p-4 text-center">
          <p className="text-white text-xl cursor-pointer flex font-bold gap-2">
            Resume md shakil hossain <span className='font-bol font-extrabold mt-[6px]' style={{ transform: 'rotate(-45deg)' }}>
  <ArrowRight />
</span>
          </p>
        </div>
      </a>
    </button>
  );
};

export default ResumeButton;
// Md%20Shakil%20Hossain%20-%20FullStack-Engineer_Resume.pdf